import api from "../../api";
/* eslint-disable */
export default {
  namespaced: true,
  state: {
    UserCancellationReason: [],
  },
  getters: {
    getUserCancellationReason(state) {
      return state.UserCancellationReason;
    },
  },
  mutations: {
    SetUserCancellationReason(state, data) {
      
      state.UserCancellationReason = [];
      state.UserCancellationReason = data;
    },
  },
  actions: {
    getUserCancellationReason({ commit }) {
      return new Promise((resolve, rej) => {
      api()
        .post(
          `userCancellationReason/getUserCancellationReason`,
          {},
          {
            headers: {
              Authorization: localStorage.getItem("JwtToken"),
            },
          }
        )
        .then((res) => {
          resolve(res);
          commit("SetUserCancellationReason", res.data);
        })
        .catch((err) => console.log(err));})
    },
   

    addUserCancellationReason({  }, data) {
      return new Promise((resolve, rej) => {
        api()
          .post(
            `userCancellationReason/addUserCancellationReason`,
            data,
            {
              headers: {
                Authorization: localStorage.getItem("JwtToken"),
              },
            }
          )
          .then((res) => {
            resolve(res);
          })
          .catch((err) => {
            resolve(err.response);
          });
      });
    },
    editUserCancellationReason(
      { dispatch },
      data
    ) {
      return new Promise((resolve, rej) => {
        api()
          .post(
            `userCancellationReason/editUserCancellationReason`,
            data,
            {
              headers: {
                Authorization: localStorage.getItem("JwtToken"),
              },
            }
          )
          .then((res) => {

            resolve(res);

          })
          .catch((err) => {
            resolve(err.response);
          });
      });
    },

    deleteUserCancellationReason({ dispatch }, id) {
      return new Promise((resolve, rej) => {
        api()
          .post(
            `userCancellationReason/deleteUserCancellationReason`,
            { id: id },
            {
              headers: {
                Authorization: localStorage.getItem("JwtToken"),
              },
            }
          )
          .then((res) => {

            resolve(res);

          })
          .catch((err) => {
            resolve(err.response);
          });
      });
    },

  },
};
